import AwesomeDebouncePromise from 'awesome-debounce-promise';

import { SnomedApi } from '@api/SnomedApi';

class SnomedService {
    private findApi = AwesomeDebouncePromise(SnomedApi.getList, 500);

    public async getById(id: string) {
        return SnomedApi.getById(id);
    }

    public async getList(query: string) {
        return this.findApi(query);
    }
}

export const snomedService = new SnomedService();
